import * as React from 'react'

import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~/client/src/shared/components/shadcn-ui/dialog'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import MaterialsUploadStore from '../MaterialsUpload.store'

// localization: translated

interface IProps {
  store: MaterialsUploadStore
  titleRenderer(title: string): JSX.Element
}

@observer
export default class ReplaceExistingMaterialsDialog extends React.Component<IProps> {
  public render() {
    const { store, titleRenderer } = this.props
    const {
      isReplaceDataDialogShown,
      resetInitialValues,
      uploadNewMaterialsExcel,
    } = store

    return (
      <Dialog open={isReplaceDataDialogShown}>
        <DialogContent showCloseButton={false}>
          <DialogHeader>
            <DialogTitle render={<div />}>
              {titleRenderer(Localization.translator.confirmDeletion)}
            </DialogTitle>
          </DialogHeader>
          <div className="relative">
            <div className="text large light">
              {
                Localization.translator.materialsUploadConfirm
                  .replaceDescription
              }
            </div>
          </div>
          <DialogFooter>
            <Button
              variant="outline"
              className="tw:grow"
              onClick={resetInitialValues}
            >
              {Localization.translator.cancel}
            </Button>
            <Button
              variant="destructive"
              className="tw:grow"
              onClick={uploadNewMaterialsExcel}
            >
              {Localization.translator.delete}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    )
  }
}
